export const roles = {
  GLOBAL_ADMIN: {id: 1, name: 'Global Admin'},
  ADMIN: {id: 2, name: 'QUADA - Admin'},
  FINANCE_SPECIALIST: {id: 3, name: 'QUADA - Finance Specialist'},
  ACCREDITATION_SPECIALIST: {id: 4, name: 'QUADA - Accreditation Specialist'},
  SURVEY_ADMIN: {id: 5, name: 'QUADA - Scheduling Team'},
  INVESTIGATOR: {id: 6, name: 'Investigator'},
  CLINICAL_REVIEWER: {id: 7, name: 'QUADA - Clinical Reviewer'},
  ACCREDITATION_DIRECTOR: {id: 8, name: 'QUADA - Accreditation Director'},
  SURVEYOR_LEAD: {id: 9, name: 'Surveyor Lead'},
  SURVEYOR: {id: 10, name: 'QUADA - Surveyor'},
  INVESTIGATION_ADMIN: {id: 11, name: 'QUADA - Investigation Admin'},
  INVESTIGATION_DIRECTOR: {id: 12, name: 'QUADA - Investigation Director'},
  FINANCE_DIRECTOR: {id: 13, name: 'QUADA - Finance Director'},
  DIRECTOR: {id: 14, name: 'QUADA - Director'},
  FACILITY_ADMIN: {id: 15, name: 'Facility Admin'},
  BILLING_ADMIN: {id: 16, name: 'Billing Admin'},
  MEDICAL_DIRECTOR: {id: 17, name: 'Medical Director'},
  CONSULTANT: {id: 18, name: 'Consultant'},
  FACILITY_CONTACT: {id: 19, name: 'Facility Contact'},
  REGULATORY_DIRECTOR: {id: 46, name: 'QUADA - Regulatory Director'},
  OWNER: {id: 23, name: 'Owner'},
  STAFF: {id: 20, name: 'Staff'},
  PHYSICIAN: {id: 21, name: 'Physician'},
  PHYSICAL_THERAPIST: {id: 38, name: 'Physical Therapist'},
  NURSE: {id: 32, name: 'Nurse'},
  DENTIST: {id: 44, name: 'Dentist'},
  SPEECH_LANGUAGE_PATHOLOGIST_ASSISTANT: {id: 42, name: 'Speech Language Pathologist Assistant'},
  SPEECH_LANGUAGE_PATHOLOGIST: {id: 48, name: 'Speech Language Pathologist'},
  CLINIC_ADMINISTRATOR: {id: 17, name: 'Clinic Administrator'},
  SURGEON_PROCEDURALIST: {id: 29, name: 'Surgeon/Proceduralist'},
  ANESTHESIA_PROVIDER: {id: 31, name: 'Anesthesia Provider'},
  NURSE_PRACTITIONER: {id: 34, name: 'Nurse Practitioner'},
  PHYSICIAN_ASSISTANT: {id: 35, name: 'Physician Assistant'},
  LICENSED_CLINICAL_SOCIAL_WORKER: {id: 36, name: 'Licensed Clinical Social Worker'},
  NURSE_MIDWIFE: {id: 37, name: 'Nurse Midwife'},
  OCCUPATIONAL_THERAPIST: {id: 39, name: 'Occupational Therapist'},
  PHYSICAL_THERAPIST_ASSISTANT: {id: 40, name: 'Physical Therapist Assistant'},
  OCCUPATIONAL_THERAPIST_ASSISTANT: {id: 41, name: 'Occupational Therapist Assistant'},
  MEDICAL_DIRECTOR_CLINIC_ADMINISTRATOR: {id: 17, name: 'Medical Director(Clinic Administrator)'},
  BILLING_CONTACT: {id: 27, name: 'Billing Contact'},
  SCHEDULING_TEAM: {id: 5, name: 'QUADA - Scheduling Team'},
  ADMIN_LITE: {id: 49, name: 'Admin Lite'},
  BUSINESS_DEVELOPER: {id: 50, name: 'QUADA - Business Developer'},
  CLINICAL_PSYCHOLOGIST: {id: 51, name: 'Clinical Psychologist'},
  MARRIAGE_AND_FAMILY_THERAPIST: {id: 52, name: 'Marriage and Family Therapist'},
  MENTAL_HEALTH_COUNSELOR: {id: 53, name: 'Mental Health Counselor'}
};

export function staffRoles(): { id: number, name: string }[] {
  return [
    roles.OWNER,
    roles.MEDICAL_DIRECTOR,
    roles.CLINIC_ADMINISTRATOR,
    roles.FACILITY_CONTACT,
    roles.PHYSICIAN,
    roles.PHYSICIAN_ASSISTANT,
    roles.BILLING_CONTACT,
    roles.OCCUPATIONAL_THERAPIST,
    roles.OCCUPATIONAL_THERAPIST_ASSISTANT,
    roles.PHYSICAL_THERAPIST,
    roles.PHYSICAL_THERAPIST_ASSISTANT,
    roles.LICENSED_CLINICAL_SOCIAL_WORKER,
    roles.NURSE,
    roles.NURSE_MIDWIFE,
    roles.NURSE_PRACTITIONER,
    roles.SPEECH_LANGUAGE_PATHOLOGIST,
    roles.SPEECH_LANGUAGE_PATHOLOGIST_ASSISTANT,
    roles.SURGEON_PROCEDURALIST,
    roles.FACILITY_ADMIN,
    roles.BILLING_ADMIN,
    roles.DENTIST,
    roles.CLINICAL_PSYCHOLOGIST,
    roles.MARRIAGE_AND_FAMILY_THERAPIST,
    roles.MENTAL_HEALTH_COUNSELOR,
    roles.STAFF
  ];
}

export function licenseRoles(): { id: number, name: string }[] {
  return [
    roles.PHYSICIAN,
    roles.PHYSICAL_THERAPIST,
    roles.NURSE,
    roles.DENTIST,
    roles.SPEECH_LANGUAGE_PATHOLOGIST,
    roles.SPEECH_LANGUAGE_PATHOLOGIST_ASSISTANT,
    roles.MEDICAL_DIRECTOR,
    roles.CLINIC_ADMINISTRATOR,
    roles.PHYSICIAN_ASSISTANT,
    roles.OCCUPATIONAL_THERAPIST,
    roles.OCCUPATIONAL_THERAPIST_ASSISTANT,
    roles.PHYSICAL_THERAPIST_ASSISTANT,
    roles.ANESTHESIA_PROVIDER,
    roles.LICENSED_CLINICAL_SOCIAL_WORKER,
    roles.NURSE_MIDWIFE,
    roles.NURSE_PRACTITIONER,
    roles.SURGEON_PROCEDURALIST,
  ];
}

export function facilityRoles(): { id: number, name: string }[] {
  return [
    roles.FACILITY_ADMIN,
    roles.BILLING_ADMIN,
    roles.MEDICAL_DIRECTOR,
    roles.CONSULTANT,
    roles.STAFF,
    roles.FACILITY_CONTACT,
    roles.BILLING_CONTACT
  ];
}

export function surveyFacilityRoles(): { id: number, name: string }[] {
  return [
    roles.FACILITY_ADMIN,
    roles.MEDICAL_DIRECTOR,
    roles.CONSULTANT,
    roles.FACILITY_CONTACT,
    roles.STAFF // TODO check if needed here
  ];
}

export function facilityMainContactRoles(): { id: number, name: string }[] {
  return [
    roles.MEDICAL_DIRECTOR,
    roles.FACILITY_CONTACT,
    roles.CLINIC_ADMINISTRATOR,
    roles.MEDICAL_DIRECTOR_CLINIC_ADMINISTRATOR,
    roles.GLOBAL_ADMIN
  ];
}

export function isFacilityContact(): { id: number, name: string }[] {
  return [
    roles.FACILITY_CONTACT
  ];
}

export function asfRoles(): { id: number, name: string }[] {
  return [
    roles.ACCREDITATION_DIRECTOR,
    roles.ACCREDITATION_SPECIALIST,
    roles.GLOBAL_ADMIN,
    roles.CLINICAL_REVIEWER,
    roles.REGULATORY_DIRECTOR,
    roles.INVESTIGATION_ADMIN,
    roles.INVESTIGATION_DIRECTOR,
    roles.SURVEY_ADMIN,
    roles.ADMIN_LITE,
    roles.SURVEYOR_LEAD,
    roles.SURVEYOR
  ];
}

export function aaaasfRoles(): { id: number, name: string }[] {
  return [
    roles.ACCREDITATION_DIRECTOR,
    roles.ACCREDITATION_SPECIALIST,
    roles.INVESTIGATION_ADMIN,
    roles.INVESTIGATION_DIRECTOR,
    roles.INVESTIGATOR,
    roles.DIRECTOR,
    roles.GLOBAL_ADMIN,
    roles.ADMIN_LITE,
    roles.CLINICAL_REVIEWER,
    roles.ADMIN,
    roles.SURVEY_ADMIN,
    roles.SURVEYOR,
    roles.SURVEYOR_LEAD,
    roles.FINANCE_SPECIALIST,
    roles.FINANCE_DIRECTOR,
    roles.REGULATORY_DIRECTOR,
    roles.STAFF
  ];
}

export function aaaasfRolesWithoutStaff(): { id: number, name: string }[] {
  return [
    roles.ACCREDITATION_DIRECTOR,
    roles.ACCREDITATION_SPECIALIST,
    roles.INVESTIGATION_ADMIN,
    roles.INVESTIGATION_DIRECTOR,
    roles.INVESTIGATOR,
    roles.DIRECTOR,
    roles.GLOBAL_ADMIN,
    roles.ADMIN_LITE,
    roles.CLINICAL_REVIEWER,
    roles.ADMIN,
    roles.SURVEY_ADMIN,
    roles.SURVEYOR,
    roles.SURVEYOR_LEAD,
    roles.FINANCE_SPECIALIST,
    roles.FINANCE_DIRECTOR,
    roles.REGULATORY_DIRECTOR
  ];
}

export function fourAsfRoles(): { id: number, name: string }[] {
  return [
    roles.ACCREDITATION_DIRECTOR,
    roles.ACCREDITATION_SPECIALIST,
    roles.INVESTIGATION_ADMIN,
    roles.INVESTIGATION_DIRECTOR,
    roles.DIRECTOR,
    roles.GLOBAL_ADMIN,
    roles.CLINICAL_REVIEWER,
    roles.ADMIN,
    roles.SURVEY_ADMIN,
    roles.SURVEYOR,
    roles.FINANCE_SPECIALIST,
    roles.FINANCE_DIRECTOR,
    roles.REGULATORY_DIRECTOR,
    roles.ADMIN_LITE
  ];
}

export function invoiceRoles(): { id: number, name: string }[] {
  return [
    roles.OCCUPATIONAL_THERAPIST,
    roles.OCCUPATIONAL_THERAPIST_ASSISTANT,
    roles.PHYSICAL_THERAPIST,
    roles.PHYSICAL_THERAPIST_ASSISTANT,
    roles.SPEECH_LANGUAGE_PATHOLOGIST,
    roles.SPEECH_LANGUAGE_PATHOLOGIST_ASSISTANT,
    roles.PHYSICIAN,
    roles.PHYSICIAN_ASSISTANT,
    roles.LICENSED_CLINICAL_SOCIAL_WORKER,
    roles.NURSE_MIDWIFE,
    roles.NURSE_PRACTITIONER,
    roles.CLINICAL_PSYCHOLOGIST,
    roles.MARRIAGE_AND_FAMILY_THERAPIST,
    roles.MENTAL_HEALTH_COUNSELOR
  ];
}
